import React from 'react';
import { Wine, Target, Zap, Trophy } from 'lucide-react';

const features = [
  {
    icon: Wine,
    title: 'Bar-Specific Names',
    description: 'Names tailored for pubs, cocktail lounges, and sports bars.'
  },
  {
    icon: Target,
    title: 'Style Options',
    description: 'Choose from traditional, modern, or themed bar names.'
  },
  {
    icon: Zap,
    title: 'Instant Generation',
    description: 'Get unique bar names in seconds.'
  },
  {
    icon: Trophy,
    title: 'Memorable Names',
    description: 'Names that attract customers and build your brand.'
  }
];

export default function BarFeatures() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
          Why Choose Our Bar Name Generator?
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="text-center p-6 rounded-lg border border-amber-200 hover:shadow-lg transition-shadow">
              <feature.icon className="w-12 h-12 text-amber-500 mx-auto mb-4" />
              <h3 className="text-xl font-semibold text-gray-900 mb-2">{feature.title}</h3>
              <p className="text-gray-600">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}